const StickerPage = () => import('client/StickerPage/StickerPage.vue');

export default [
  {
    path: '/stickerpage',
    name: 'stickerpage',
    meta: {
      title: 'Sticker Page',
      loadLegacyStyles: false,
    },
    components: {
      mainPanel: StickerPage,
    },
  },
  {
    path: '/legacy-stickerpage',
    name: 'legacy stickerpage',
    meta: {
      title: 'Sticker Page (Legacy Styles)',
    },
    components: {
      mainPanel: StickerPage,
    },
  },
];
